<template>
    <el-dialog
            title="导入"
            :visible.sync="shown"
            class="editor-dowload-layer"
            :before-close="()=>handleCancel()"
    >
        <div class="editor-dowload-layer-wrap">
            导入
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name: "EditorDowload",
        props: ['shown'],
        data() {
            return {}
        },

        methods: {

            //取消
            handleCancel() {
                this.$nextTick(() => {
                    this.$emit("handleCancel");
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "./assets/style.less";
</style>